import { Reveal } from "./Reveal";
import { CONTACT } from "../../content";
import { useT } from "../../i18n/LangContext";

export const Help = () => {
  const r = useT().ride;
  return (
    <section id="help" className="scroll-mt-16 bg-white px-5 py-16 sm:px-8 lg:py-20" data-testid="ride-now-section">
      <Reveal className="mx-auto max-w-7xl">
        <div className="rounded-xl bg-[#F3F3F3] p-7 sm:p-10 lg:flex lg:items-center lg:justify-between lg:gap-10">
          <div>
            <h2 className="text-[28px] font-bold leading-tight tracking-[-0.02em] text-black lg:text-[36px]">
              {r.title1} {r.title2}
            </h2>
            <p className="mt-3 max-w-lg text-base text-zinc-600">{r.text}</p>
            <a href={CONTACT.tel} className="mt-4 inline-block text-xl font-bold text-black" data-testid="ride-now-phone">
              {CONTACT.phoneDisplay}
            </a>
          </div>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row lg:mt-0 lg:shrink-0">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-lg bg-black px-6 py-3.5 text-center text-base font-medium text-white transition-colors hover:bg-zinc-800"
              data-testid="ride-now-whatsapp-btn"
            >
              {r.whatsapp}
            </a>
            <a
              href={CONTACT.tel}
              className="rounded-lg border border-black/30 px-6 py-3.5 text-center text-base font-medium text-black transition-colors hover:bg-black/10"
              data-testid="ride-now-call-btn"
            >
              {r.call}
            </a>
          </div>
        </div>
        <a
          href={CONTACT.website}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-block text-sm text-zinc-700 underline underline-offset-4 hover:text-black"
          data-testid="ride-now-website-link"
        >
          {r.website}
        </a>
      </Reveal>
    </section>
  );
};
